import React from "react";
import { AppBar, Toolbar, Link, Box, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from './ThemeContext';

export default function TopBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const menuItems = [
    { label: "Home", id: "hero", path: "/" },
    { label: "Skills", id: "skills", path: "/#skills" },
    { label: "Contact", id: "contact", path: "/#contact" },
    { label: "Imagine", id: "imagine", path: "/imagine" },
    { label: "Theater", id: "theater", path: "/theater" },
    { label: "Stocks", id: "stocks", path: "/stocks" },
    { label: "Admin", id: "admin", path: "/admin" }
  ];

  // Helper to scroll to section after navigation
  const scrollToSection = (id) => {
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <AppBar position="sticky" sx={{ background: 'var(--pacific-cyan)', boxShadow: '0 1px 0 rgba(0,0,0,0.1)', py: 1 }} elevation={0}>
      <Toolbar sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', px: { xs: 2, sm: 4 } }}>
        <Link
          href="/"
          underline="none"
          sx={{ fontWeight: 700, fontFamily: "'IBM Plex Mono', monospace", color: 'var(--white)', letterSpacing: -0.5, fontSize: '1.3rem', cursor: 'pointer', flexShrink: 0 }}
        >
          Sid Kumaran
        </Link>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            ml: 2,
            overflowX: { xs: 'auto', sm: 'visible' },
            whiteSpace: { xs: 'nowrap', sm: 'normal' },
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            alignItems: 'center',
            // Hide scrollbar on mobile
            '&::-webkit-scrollbar': { display: 'none' },
            '-ms-overflow-style': 'none',
            'scrollbarWidth': 'none',
            flexGrow: 1,
            minWidth: 0,
          }}
        >
          {menuItems.map((item) => (
            <Link
              key={item.label}
              underline="none"
              href={item.path}
              sx={{
                ml: 4,
                fontWeight: 600,
                fontSize: '0.95rem',
                color: 'var(--white)',
                cursor: 'pointer',
                flexShrink: 0,
                transition: 'color 0.2s ease',
                opacity: 0.8,
                '&:hover': {
                  color: 'var(--white)',
                  opacity: 1
                }
              }}
              onClick={e => {
                if (item.path.startsWith('/#')) {
                  e.preventDefault();
                  if (location.pathname !== '/') {
                    navigate('/', { replace: false });
                    setTimeout(() => scrollToSection(item.id), 200);
                  } else {
                    scrollToSection(item.id);
                  }
                }
              }}
            >
              {item.label}
            </Link>
          ))}
          <IconButton aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`} sx={{ ml: 2, color: 'var(--white)', flexShrink: 0 }} onClick={toggleTheme} color="inherit">
            {theme === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
